
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/neat-vs-shoeboxed",
      function () {
        return require("private-next-pages/neat-vs-shoeboxed.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/neat-vs-shoeboxed"])
      });
    }
  